import React from "react";
import styles from "./ShopifyEdge.module.css";

export default function ShopifyEdge() {
  // Provided embed URLs (as requested)
  const embeds = [
    "https://www.linkedin.com/embed/feed/update/urn:li:share:7434435238476271616?collapsed=1",
    "https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7447787491467718656?collapsed=1",
    "https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7445475478087573504?collapsed=1",
    "https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7445835671921049600?collapsed=1",
    "https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7446159605187104768?collapsed=1",
    "https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7447221359404949504?collapsed=1",
  ];

  // Replace these placeholders with your actual profile/channel URLs
  const linkedInProfile = "https://www.linkedin.com/in/hasan-mahmoud-483366170/";
  const youtubeChannel = "https://www.youtube.com/@hasanmahmoud4546";

  return (
    <>
      <section className={`${styles.shopifyEdge} container`}>
        <div className={styles.content}>
            <div className={styles.description}>
            <h1>Shopify Edge — Posts</h1>
            <p>
              Publishing Shopify engineering tips, performance solutions, and developer-focused videos on LinkedIn and YouTube.
            </p>

            <div className={styles.actionButtons}>
              <a
                className={styles.viewButton}
                href={linkedInProfile}
                target="_blank"
                rel="noreferrer"
              >
                View LinkedIn Profile
              </a>

              <a
                className={styles.viewButton}
                href={youtubeChannel}
                target="_blank"
                rel="noreferrer"
              >
                View YouTube Channel
              </a>
            </div>
          </div>
            <div className={`col-12 ${styles.embedCard}`}>
              <div className={styles.videoFrame}>
                <iframe
                  src="https://www.youtube.com/embed/B72sK01RxJw"
                  title="هل الـذكاء الأصطناعي هيستبدل المطورين ومستقبل البرمجة بعد 2026 ؟"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
            <div className="row">
            {embeds.length === 0 && (
              <div className={styles.placeholder}>
                No LinkedIn embeds found. Edit this component and add your
                LinkedIn embed URLs to the `embeds` array.
              </div>
            )}

            {embeds.map((src, idx) => (
              <div className={`col-12 col-sm-6 col-md-6 col-lg-4 ${styles.embedCard}`} key={idx}>
                <div className={styles.embedFrame}>
                  <iframe
                    src={src}
                    title={`linkedin-embed-${idx}`}
                    frameBorder="0"
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="strict-origin-when-cross-origin"
                  ></iframe>
                </div>
              </div>
            ))}
            
          </div>
          {/* add the embed video here */}
        </div>
      </section>
    </>
  );
}
